import { Span, TextProps } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

export const SpanWithAfterDownArrow = styled(Span)<TextProps>`
  display: inline-block;
  white-space: nowrap;
  font-weight: 400;

  :hover {
    text-decoration: underline;
  }

  ::after {
    content: "\\203A";
    display: inline-block;
    vertical-align: middle;
    transform: rotate(90deg);
    margin-left: 0.4375rem;
    font-weight: 800;
    line-height: 0.875rem;
    font-size: ${themeGet("fontSizes.sm")};
  }
`;

export default SpanWithAfterDownArrow;
